module.exports = __webpack_public_path__ + "assets/img/4@3x.b9899f56.png";